import React ,{useState,useEffect}  from 'react';
import { Link } from 'react-router-dom';
// import './about.css';
import missionimg from './images/solution-img2.png'
import mission1 from './images/mission2[1].jpg'
import mission2 from './images/mission8.jpg'
import chip from './images/chip.png'
import idea from './images/idea.png'
const About = () => {

  const values = [
    {
      title: "Innovation",
      description:
        "Innovation is embedded in our DNA. We are passionate about exploring new horizons, developing cutting-edge solutions, and pushing the boundaries of technology. Our team continuously evaluates emerging trends and integrates the latest advancements to create solutions that not only address current needs but also anticipate future challenges.",
    },
    {
      title: "Expertise",
      description:
        "Our team is composed of industry experts and visionary innovators dedicated to excellence in every aspect of our work. With deep expertise in data analytics, AI, automation, cloud computing, and more, we bring together a wealth of knowledge and skills to provide comprehensive and customized solutions.",
    },
    {
      title: "Collaboration",
      description:
        "At Prophecy Technologies, we believe in the power of partnership. Our collaborative approach fosters a close working relationship with our clients, allowing us to co-create solutions that deliver tangible results. We work hand-in-hand with clients to understand their unique challenges and goals.",
    },
    {
      title: "Commitment to Excellence",
      description:
        "Excellence is more than just a goal for us; it’s a standard. We hold ourselves to the highest standards of quality in every project we undertake, from initial consultation to final delivery. Our commitment to excellence is reflected in our rigorous quality assurance processes and dedication to providing superior service.",
    },
  ];

  return (
    <>
    <div className="about-container">
      <div className="about-banner">
        <h1>About Us</h1> 

        {/* <p>
          <span className="breadcrumb">Home</span> &gt; <span className="breadcrumb-active">About</span>
        </p> */}
      </div>
      <div class="about-navigation">
  <ul class="nav-list">
    <li>✴ Manage IT Services</li>
    <li>✴ Network Solutions</li>
    <li>✴ Consulting</li>
    <li>✴ Data Analytics</li>
    <li>✴ Cloud Solutions</li>
    <li>✴ Cybersecurity</li>
   
    <li>✴ Data Analytics</li>
    <li>✴ Manage IT Services</li>
    <li>✴ Network Solutions</li>
    <li>✴ Consulting</li>
    <li>✴ Cloud Solutions</li>
    <li>✴ Cybersecurity</li>
  </ul>
</div>

    </div>


{/* Mission Section */}
<div className="mission-section">
  
<div className="mission-content">
  <h3>-Our Mission-</h3>
  <h2>Empowering Innovation: Our Technology Mission
  </h2>
  <p>
  At Cognifyar, our mission is to empower businesses by delivering cutting-edge technology solutions that drive growth, efficiency, and sustainability. We are committed to being the trusted partner that helps organizations navigate the complexities of the digital era.
  
  </p>
  <p className="quote">
  We envision a future where technology serves as a catalyst for limitless possibilities, fostering progress and prosperity for all. Cognifyar is committed to empowering businesses and individuals to harness the transformative power of technology, enabling them to overcome challenges, capitalize on opportunities, and achieve their highest potential.
  </p>
  {/* <button className="discover-button">Discover More &rarr;</button> */}
</div>
<div className="image-about">
      {/* Main image */}
      <div className="main-image">
        <img
          src={missionimg}
          alt="Main"
        />
      </div>

      {/* Top-right small image */}
      <div className="small-image top-right">
        <img
          src={mission1}
          alt="Small Top Right"
        />
      </div>

      {/* Bottom-left small image */}
      <div className="small-image bottom-left">
        <img
          src={mission2}
          alt="Small Bottom Left"
        />
      </div>
    </div>
</div>

<div className="about-vision-section">
<div className="vision-images">
        <img
          src={missionimg}
          alt="Team Collaboration"
          className="vision-image large"
        />
        <div className="small-images">
          <img src={mission1} alt="Team Discussion" />
          <img src={mission2} alt="Brainstorming Session" />
        </div>
      </div>
      <div className="vision-content">
        <h3 className="section-title">
          <span className="highlight-text">-Our Vision-</span>
        </h3>
        <h2>Empowering Progress: Our Vision at Cognifyar
        </h2>
        <p className="vision-description">
        At Cognifyar, our vision is to be a global leader in driving digital transformation and innovation. We aspire to create a future where businesses of all sizes are equipped with the technology and expertise they need to succeed in a dynamic digital landscape.
        </p>
        <div className="vision-services">
          <div className="service-item">
            <i className="icon-network"> <img src={chip} alt="" /></i>
            <div>
              <h4>AI-Powered Network Solutions</h4>
              <p>
              Develop an intelligent and secure network infrastructure powered by AI to optimize operations, enhance connectivity, and ensure seamless scalability. 
              </p>
            </div>
          </div>
          <div className="service-item">
            <i className="icon-network"><img src={idea} alt="" /></i>
            <div>
              <h4>Smart Tech Network Solutions</h4>
              <p>
              Create a secure and intelligent network infrastructure powered by advanced technology to streamline operations, boost connectivity, and enable seamless scalability.
              </p>
            </div>
          </div>
        </div>
        {/* <button className="discover-more-btn">Discover More →</button> */}
      </div>
    </div>
    

    <div className="core-values-section">
      <h1 className="core-values-title">Our Core Values: <br /> What Sets Us Apart</h1>
      <p className="core-values-description">
        Cognifyar Technologies is built on a foundation of core values that
        define who we are and how we operate. Our commitment to innovation,
        expertise, collaboration, and excellence guides every decision and
        drives our dedication to helping clients achieve their strategic goals.
      </p>
      <div className="values-grid">
        {values.map((value, index) => (
          <div key={index} className="value-card">
            <div className="icon-placeholder">🔷</div>
            <h3>{value.title}</h3>
            <p>{value.description}</p>
          </div>
        ))}
      </div>
    </div>
    <section className="contact-section">
      <div className="contact-content">
        <h1 data-aos="fade-up" data-aos-delay="400">Shaping Your Future, Together</h1>
        <p data-aos="fade-up" data-aos-delay="500">
          At Cognifyar Technologies, we are committed to helping businesses realize their full potential. 
          Our goal is to empower you with innovative tools, advanced technologies, and customized strategies 
          that drive success in today’s fast-paced market. Are you ready to accelerate your digital transformation? 
          Get in touch with us today to learn how Cognifyar Technologies can help you achieve your objectives and ensure long-term growth.
        </p>
        <Link to='/Contact'> <button className="shadow-rotating-button">Take Action</button></Link>
        {/* <a href="/" className="shadow-rotating-button">
          Take Action <span>↗</span>
        </a> */}
      </div>
    </section>

</>
  );
};

export default About;